import React, { useMemo } from 'react';
import DatePicker from 'react-date-picker';
import { DateTime } from 'luxon';
import { InputErrorIcon } from 'src/assets/images';
import ShowIf from 'src/components/show-if/show-if';
import { Prompt } from 'src/features/common/components/prompt/prompt';
import { ErrorCodeTooltip } from 'src/features/common/components/error-code-tooltip/error-code-tooltip';
import { getIn } from 'formik';
import { CalendarIcon, InfoIcon } from 'src/assets/images';
import './styled-date-picker.scss';

const stringFormat = 'yyyy-MM-dd';

export const StyledDatePicker = ({ field, form, ...props }) => {
  const getFieldError = (fieldName) => getIn(form.errors, fieldName);
  const getFieldTouched = (fieldName) => getIn(form.touched, fieldName);

  const disabled = useMemo(
    () =>
      props.disabled ||
      getIn(form?.initialStatus?.initialDisabled || {}, field.name) ||
      form?.initialStatus?.initialDisabled?.[field.name],
    [props.disabled, field.name, form?.initialStatus?.initialDisabled],
  );

  const hints = useMemo(
    () =>
      props.hints ||
      getIn(form?.initialStatus?.initialHint || {}, field.name) ||
      form?.initialStatus?.initialHint?.[field.name],
    [props.hints, field.name, form?.initialStatus?.initialHint],
  );

  return (
    <div className={`date-picker-container ${hints && hints.length > 0 ? 'has-hints' : ''}`}>
      <DatePicker
        disabled={disabled}
        calendarIcon={
          <img automationid={props.automationId} className="icon-calendar" src={CalendarIcon} />
        }
        clearIcon={null}
        yearPlaceholder="----"
        format="dd/MM/y"
        value={
          !!field.value ? DateTime.fromFormat(field.value, stringFormat).toJSDate() : field.value
        }
        onChange={(value) => {
          form.setFieldValue(
            field.name,
            !!value ? DateTime.fromJSDate(value).toFormat(stringFormat) : value,
          );
          form.setFieldTouched(field.name, true);
          form.validateForm(form.values);
        }}
        onCalendarClose={() => {
          form.setFieldTouched(field.name, true);
          form.validateForm(form.values);
        }}
        minDate={!!props.minDate ? props.minDate : null}
        maxDate={!!props.maxDate ? props.maxDate : null}
      />
      <p className="date-picker-label">{props.fieldName}</p>
      <ShowIf
        condition={
          hints && hints.length > 0 && !(getFieldError(field.name) && getFieldTouched(field.name))
        }
      >
        <ErrorCodeTooltip lightMode={false} content={hints}>
          <div className="field-error hint">
            <Prompt icon={InfoIcon} center={false} />
          </div>
        </ErrorCodeTooltip>
      </ShowIf>
      <ShowIf condition={getFieldError(field.name) && getFieldTouched(field.name)}>
        <div className="field-error">
          <img className="error-image" src={InputErrorIcon} />
          <span>{getFieldError(field.name)}</span>
        </div>
      </ShowIf>
    </div>
  );
};
